import { RetailPartner } from '@generated/gql/graphql.ts';

export const padPartnersToFillRows = (
  partners: RetailPartner[],
  rows: number,
  slidesToShow: number
): RetailPartner[] => {
  if (partners.length === 0) {
    return partners;
  }

  const passCount = Math.ceil(partners.length / rows) * rows;
  const passes = Math.ceil(((slidesToShow + 1) * rows) / passCount);
  const targetCount = passes * passCount;

  if (targetCount === partners.length) {
    return partners;
  }

  return Array.from(
    { length: targetCount },
    (_, i) => partners[(i % passCount) % partners.length]
  );
};
